import {
  FC,
  useMemo,
  useCallback,
  useState,
  CSSProperties,
} from 'react';
// 组件
import { UpOutlined, CaretUpOutlined } from '@ant-design/icons';
import { ProPopover } from '../antd';
import SuperTable from '../SuperTable';
// 方法
import classNames from 'classnames';
// 常量
import { PopoverTableProps } from './interface';
import './style.less';

const contentStyle: CSSProperties = { border: 'none' };
/** 气泡表格 */
const PopoverTable: FC<PopoverTableProps> = props => {
  const {
    dataSource,
    style,
    titleKey,
    rowKey,
    columns,
    className,
    width,
    listApi,
    defauleSearchParams,
    dataKey,
    title,
    destroyOnClose,
    showTotal,
    showTitle,
    popoverIcon,
    ...restProps
  } = props;
  const [visible, setVisible] = useState<boolean>(false);
  const handleOpenChange = useCallback(
    (val: boolean) => {
      setVisible(val);
    },
    [visible],
  );
  const contentRender = useMemo(() => {
    let autoMaxHeight = window.document.body.clientHeight * 0.6;
    autoMaxHeight = autoMaxHeight < 400 ? 400 : autoMaxHeight;
    return (
      <>
        {!destroyOnClose || visible ? (
          <SuperTable
            bordered={false}
            pagination={false}
            autoHeight={false}
            autoMaxHeight={autoMaxHeight}
            toolBar={false}
            operation={false}
            listApi={listApi}
            dataSource={dataSource}
            defauleSearchParams={defauleSearchParams}
            columns={columns}
            rowKey={rowKey}
            dataKey={dataKey}
            size="small"
            wrapperStyle={{ width, padding: 0 }}
            contentStyle={contentStyle}
          />
        ) : null}
      </>
    );
  }, [dataSource, listApi, defauleSearchParams, visible]);
  const titleRender = useMemo(() => {
    if (title !== undefined) return title;
    if (Array.isArray(dataSource) && titleKey) {
      return dataSource[0]?.[titleKey];
    }
    return '';
  }, [title, dataSource, titleKey]);
  const classes = useMemo(() => {
    return classNames("yb-column-list-wrapper", className);
  }, [className]);
  return (
    <div className={classes} style={style}>
      {
        showTitle && (
          <span
            className={
              classNames(
                'yb-column-list-title',
                'yb-line-ellipsis',
                {
                  'yb-column-list-title-1': showTotal && dataSource && dataSource?.length > 1 && dataSource?.length < 10,
                  'yb-column-list-title-2': showTotal && dataSource && dataSource.length >= 10 && dataSource.length < 100,
                  'yb-column-list-title-3': showTotal && dataSource && dataSource.length >= 100 && dataSource.length < 1000,
                },
              )
            }
            title={titleRender}
          >{titleRender}</span>
        )
      }
      {
        showTotal && Array.isArray(dataSource) && dataSource.length > 1 && (
          <span
            className='yb-column-list-move'
          >
            +{dataSource.length - 1}
          </span>
        )
      }
      {
        (listApi || (Array.isArray(dataSource) && !!dataSource.length)) && (
          <ProPopover
            {...restProps}
            className="yb-column-list-icon"
            content={contentRender}
            onOpenChange={handleOpenChange}
          >
            {
              popoverIcon || (listApi ? <CaretUpOutlined /> : <UpOutlined />)
            }
          </ProPopover>
        )
      }
    </div>
  );
};

PopoverTable.defaultProps = {
  rowKey: 'key',
  placement: 'bottomRight',
  trigger: 'hover',
  width: 500,
  dataKey: false,
  destroyOnClose: false,
  showTotal: true,
  showTitle: true,
};

export default PopoverTable;
